import React from 'react';
import { Card, Typography, Button, Input } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { TextArea } = Input;

export default function ActionAcceptanceTab({
  acceptComment,
  setAcceptComment,
  acceptLoading,
  onAccept,
  requestCloseComment,
  setRequestCloseComment,
  requestCloseLoading,
  onRequestClose,
  closeComment,
  setCloseComment,
  closeLoading,
  onClose,
  primaryButtonClass,
}) {
  return (
    <Card style={{ borderRadius: 16 }} bodyStyle={{ padding: 16 }}>
      {/* پذیرش اقدام */}
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3">
        <div>
          <Title level={5} style={{ margin: 0, fontFamily: 'CustomFont' }}>
            پذیرش اقدام
          </Title>
          <Text type="secondary" style={{ fontFamily: 'CustomFont' }}>
            فقط کاربر با نقش <Text strong>مسئول اجرا</Text> می‌تواند اقدام را بپذیرد.
          </Text>
        </div>
        <Button
          type="primary"
          icon={<CheckCircleOutlined />}
          onClick={onAccept}
          loading={acceptLoading}
          className={primaryButtonClass}
          style={{ borderRadius: 14, fontFamily: 'CustomFont' }}
        >
          پذیرش اقدام
        </Button>
      </div>

      <div className="mt-4">
        <Text style={{ fontFamily: 'CustomFont' }} strong>
          توضیحات (اختیاری)
        </Text>
        <TextArea
          value={acceptComment}
          onChange={(e) => setAcceptComment(e.target.value)}
          rows={4}
          maxLength={1000}
          showCount
          placeholder="مثلاً: اقدام را پذیرفتم و شروع به کار می‌کنم"
          style={{ marginTop: 8, borderRadius: 14 }}
        />
      </div>

      {/* درخواست بستن اقدام */}
      <div className="mt-6 pt-6 border-t border-gray-200 dark:border-gray-800">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3">
          <div>
            <Title level={5} style={{ margin: 0, fontFamily: 'CustomFont' }}>
              درخواست بستن اقدام
            </Title>
            <Text type="secondary" style={{ fontFamily: 'CustomFont' }}>
              فقط <Text strong>مسئول اجرا</Text> می‌تواند درخواست بستن را برای <Text strong>پاسخگو</Text> ارسال کند.
            </Text>
          </div>
          <Button
            type="primary"
            onClick={onRequestClose}
            loading={requestCloseLoading}
            className={primaryButtonClass}
            style={{ borderRadius: 14, fontFamily: 'CustomFont' }}
          >
            ارسال درخواست بستن
          </Button>
        </div>

        <div className="mt-4">
          <Text style={{ fontFamily: 'CustomFont' }} strong>
            توضیحات (الزامی)
          </Text>
          <TextArea
            value={requestCloseComment}
            onChange={(e) => setRequestCloseComment(e.target.value)}
            rows={4}
            maxLength={1000}
            showCount
            placeholder="مثلاً: کار به اتمام رسیده است. لطفاً اقدام را ببندید."
            style={{ marginTop: 8, borderRadius: 14 }}
          />
        </div>
      </div>

      {/* بستن اقدام */}
      <div className="mt-6 pt-6 border-t border-gray-200 dark:border-gray-800">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3">
          <div>
            <Title level={5} style={{ margin: 0, fontFamily: 'CustomFont' }}>
              بستن اقدام
            </Title>
            <Text type="secondary" style={{ fontFamily: 'CustomFont' }}>
              فقط کاربر با نقش <Text strong>پاسخگو</Text> می‌تواند اقدام را ببندد.
            </Text>
          </div>
          <Button
            type="primary"
            danger
            onClick={onClose}
            loading={closeLoading}
            className="!bg-red-500 hover:!bg-red-600 !border-red-500 hover:!border-red-600 !text-white"
            style={{ borderRadius: 14, fontFamily: 'CustomFont' }}
          >
            بستن اقدام
          </Button>
        </div>

        <div className="mt-4">
          <Text style={{ fontFamily: 'CustomFont' }} strong>
            توضیحات (اختیاری)
          </Text>
          <TextArea
            value={closeComment}
            onChange={(e) => setCloseComment(e.target.value)}
            rows={4}
            maxLength={1000}
            showCount
            placeholder="مثلاً: اقدام با موفقیت بسته شد"
            style={{ marginTop: 8, borderRadius: 14 }}
          />
        </div>
      </div>
    </Card>
  );
}
